import React, { ReactNode } from 'react'
import { FormGroup, Label, Col, ColProps } from 'reactstrap'
import classnames from 'classnames'
//************************************//
import HelperIcon from "@src/components/helpers/HelperIcon"

interface InlineProps {
	label?: ColProps;
	input?: ColProps;
}

interface CustomFormGroupProps {
	inline?: boolean | InlineProps;
	title?: string | ReactNode;
	subTitle?: string;
	tooltip?: string | ReactNode;
	req?: boolean;
	className?: string;
	helperClassName?: string;
	name?: string;
	children?: ReactNode;
	triggerTooltipOnClick?: boolean;
}

const CustomFormGroup: React.FC<CustomFormGroupProps> = (props) => {
	const {
		inline,
		title,
		subTitle,
		tooltip,
		req = false,
		className = '',
		helperClassName = '',
		name,
		children,
		triggerTooltipOnClick
	} = props

	let inlineProps: InlineProps = {}
	switch (typeof inline) {
		case 'boolean': inlineProps = { label: { sm: 3 }, input: { sm: 9 } }; break // default
		case 'object': inlineProps = inline; break // change default
	}

	return (
		<FormGroup className={classnames('form-group', className, {
			["row"]: inline,
			"align-items-start": inline
		})}>
			{title && (
				// @ts-ignore
				<Label for={name} className="d-flex flex-column" {...(inline && inlineProps ? inlineProps.label : {})}>
					<span className="d-flex">
						<span className={classnames({ 'req-star': req })}>{title}</span>
						{tooltip &&
							<HelperIcon triggerTooltipOnClick={triggerTooltipOnClick} className={helperClassName} name={name} text={tooltip} />
						}
					</span>
					{subTitle && <span className="text-muted font-small-3">{subTitle}</span>}
				</Label>
			)}
			{inline ? (<Col {...inlineProps.input}>{children}</Col>) : children}
		</FormGroup>
	)
}

export default CustomFormGroup
